// Pathify
import Vue from 'vue'
import { make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'
import { format, parse } from 'date-fns'

Vue.use(router)

// Data
const state = {
  operation_date: format(new Date(), 'yyyy-MM-dd'),
  options: {},
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
  },
  search (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/daily-flight/search', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
          reject(error)
      })
    })
  },
  fetch (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/daily-flight/' + payload.id).then(result => {
        result.data.takeoff_time = result.data.takeoff_time ? format(parse(result.data.takeoff_time, 'HH:mm:ss', new Date()), 'HH:mm') : ''
        result.data.landing_time = result.data.landing_time ? format(parse(result.data.landing_time, 'HH:mm:ss', new Date()), 'HH:mm') : ''
        result.data.tow_landing_time = result.data.tow_landing_time ? format(parse(result.data.tow_landing_time, 'HH:mm:ss', new Date()), 'HH:mm') : ''
        resolve(result.data)
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  update (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/daily-flight', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  takeoff (context, payload) {
    console.log(payload)
    return new Promise((resolve, reject) => {
      axios.patch('/api/daily-flight/takeoff', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  landing (context, payload) {
    console.log(payload)
    return new Promise((resolve, reject) => {
      axios.patch('/api/daily-flight/landing', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  towLanding (context, payload) {
    console.log(payload)
    return new Promise((resolve, reject) => {
      axios.patch('/api/daily-flight/tow-landing', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  dailyStatPlane (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/daily-flight/plane-stat', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  dailyStatUser (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/daily-flight/user-stat', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  duplicate (context, payload) {
     return new Promise((resolve, reject) => {
      axios.put('/api/daily-flight', {
        date: payload.date,
        pic_id: payload.pic_id,
        sic_id: payload.sic_id,
        plane_id: payload.plane_id,
        record_type: 'pre-flight',
        takeoff_airport_id: payload.takeoff_airport_id,
        takeoff_type_id: payload.takeoff_type_id,
        task_id: payload.task_id,
        tow_plane_id: payload.competitionModuleOn ? null : payload.tow_plane_id,
        pay_comment: payload.competitionModuleOn ? payload.pay_comment : null,
        instructor_id: payload.instructor_id,
      })
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  duplicateLastDay (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/daily-flight/duplicate-last-day', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  getLastFlight (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/daily-flight/get-last-flight', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  insert (context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/daily-flight', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  delete (context, payload) {
    console.log(payload)
    return new Promise((resolve, reject) => {
      axios.delete('/api/daily-flight/' + payload.id, payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  changeTowPlane (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/daily-flight/change-tow-plane', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
